import React, { useEffect, useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { toast } from 'react-toastify';

interface MessageItem {
  id: string;
  text: string;
}

const NotificationSocket: React.FC = () => {
  const { user } = useAuth();
  const [messages, setMessages] = useState<MessageItem[]>([]);

  useEffect(() => {
    const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    // API URL과 같은 호스트/포트로 WebSocket 연결
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080';
    const wsHost = new URL(apiUrl).host;
    const wsUrl = user 
      ? `${wsProtocol}//${wsHost}?userId=${user.id}`
      : `${wsProtocol}//${wsHost}`;
    
    const ws = new WebSocket(wsUrl);
    let isClosed = false;

    ws.onopen = () => {
      if (isClosed) {
        ws.close();
      }
    };
    
    ws.onmessage = (event) => {
      try {
        const payload = JSON.parse(event.data);
        if (payload.type === 'system') {
          console.log(`[WebSocket System]: ${payload.text}`);
        } else if (payload.type === 'notification') {
          // 실시간 알림 토스트 노출
          toast.info(payload.data.message, {
            position: "top-right",
            autoClose: 5000,
          });
        } else if (payload.type === 'comment_change') {
          window.dispatchEvent(new CustomEvent('comment_change', { detail: payload }));
        }
      } catch (err) {
        // 일반 텍스트 처리
        const id = `${Date.now()}-${Math.random()}`;
        const newMessage: MessageItem = { id, text: event.data };
        
        setMessages(msgs => [...msgs, newMessage]);

        setTimeout(() => {
          setMessages(msgs => msgs.filter(msg => msg.id !== id));
        }, 3000);
      }
    };
    
    return () => {
      isClosed = true;
      if (ws.readyState === WebSocket.OPEN) {
        ws.close();
      }
    };
  }, [user]);

  return (
    <div style={{ position: 'fixed', bottom: 24, right: 24, zIndex: 1000 }}>
      {messages.map((msg) => (
        <div 
          key={msg.id} 
          style={{ 
            background: '#1976d2', 
            color: '#fff', 
            padding: '12px 24px', 
            borderRadius: 8, 
            marginBottom: 8, 
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)' 
          }}
        >
          {msg.text}
        </div>
      ))}
    </div>
  );
};
export default NotificationSocket; 
